import { Box, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

export const NewUserTableSkeleton = () => {
    return (
        <Box sx={{ flexGrow: 1 }}>
            <TableContainer
                component={Paper}
                sx={{ flexGrow: 1, overflowY: 'auto', maxHeight: '270px' }}
            >
                <Table stickyHeader size="medium" aria-label="scrollable table">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontSize: '12px' }}>Full Name</TableCell>
                            <TableCell sx={{ fontSize: '12px' }}>Email Address</TableCell>
                            <TableCell sx={{ fontSize: '12px' }}>Program</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.from({ length: 5 }).map((_, index) => (
                            <TableRow key={index}>
                                <TableCell>
                                    <Skeleton variant="text" width="80%" height={20} />
                                </TableCell>
                                <TableCell>
                                    <Skeleton variant="text" width="90%" height={20} />
                                </TableCell>
                                <TableCell>
                                    <Skeleton variant="text" width="70%" height={20} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};